import { render, staticRenderFns } from "./WaiterChat.vue?vue&type=template&id=70edbaac&scoped=true&"
import script from "./WaiterChat.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WaiterChat.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WaiterChat.vue?vue&type=style&index=0&id=70edbaac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70edbaac",
  null
  
)

export default component.exports